import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService} from 'ng-jhipster';
import {ModalDirective} from 'ngx-bootstrap';
import {Principal,StateStorageService} from 'src/app/core';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {TdisConstants} from 'src/app/shared/constants/tdis-constants';
import {currenyMaskService} from 'src/app/shared/currencyMask.service';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {environment} from 'src/environments/environment';
import {AdditionalPremiumRatePostData} from '../loss-payee-my-suffix/additionalPremiumRatePostData';
import {ManualRequestsService} from '../manual-requests/manual-requests.service';
import {BulkDeclarationService} from './bulk-declaration.service';
declare let $: any;

@Component({
    selector: 'jhi-bulk-declaration-rules-checked',
    // templateUrl: './bulk-declaration-rules-checked.component.html',
    templateUrl: './bulk-declaration-rules-checked-new.component.html',
    styles: []
})
export class BulkDeclarationRulesCheckedComponent implements OnInit {
    rulesData: any = [];
    certificateRequestId: number;
    totalRules: number;
    showPushNotification = false;
    openRequest: boolean = false;

    loader=environment.loader;

    public readonly RoleUtil = RoleUtil;
    readonly TdisConstants = TdisConstants;
    
    successRules: number;

    failedRules: number;
    certificateRules: any;
    isLoader = false;
    isVesselScreeningEnabled = false;

    isCollapsed: boolean = true;
    isCollapsedArr: boolean[] = [];
    additionalPremiumRate: number = null;
    // remarks: string = null;
    remarks: any[] = [];
    approvedBy: string = null;
    approvedDate: Date = null;
    calculateAdditionalPremiumRate: number = null;
    ratePrecisionOptions: any;
    // additionalPremium: number = null;
    additionalPremiumArr: any[] = [];
    additionalPremiumRatePostData: AdditionalPremiumRatePostData = new AdditionalPremiumRatePostData();
    sumInsuredInPolicyCurrency: number = null;
    netPremium: any;
    isRulesVerifiedClicked: boolean = false;
    isAutoQuotationDisabled: any;
    isPremiumCalculationDisable: boolean = false;
    additionalPremiumRateAll;
    additionalPremiumAll;
    remarksForAll='';
    summaryDetails;
    @ViewChild("vesselNameModal") vesselNameModal: ModalDirective;
    selectedRule;
  selectedRuleIndex;
  
  isAnyRuleApprovedManually=false;

    constructor(
        private manualRequestsService: ManualRequestsService,
        private activatedRoute: ActivatedRoute,
        private currenyMask: currenyMaskService,
        private router: Router,
        private jhiAlertService: JhiAlertService,
        private stateStorageService: StateStorageService,
        private bulkDeclarationService: BulkDeclarationService,
        private languageChangeService:LanguageChangeService,
        private principal: Principal

    ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back();
            }
    });
     }

    ngOnInit() {
        this.ratePrecisionOptions = this.currenyMask.ratePrecisionOptions;
        this.isLoader = true;
        this.certificateRequestId = this.activatedRoute.snapshot.params.certificateRequestId;
        this.rulesData = [];
       
        this.checkPremiumCalculationPermission();
        this.getAllRules();
    }

    // get all requests
    getAllRules() {
        let url ;
        if(this.router.url.includes('/open-rules-check')){
            this.openRequest = true;
            url = 'api/open-bulk-certificate-manual-requests/' + this.certificateRequestId;
          }else{
            this.openRequest = false;
            url = 'api/bulk-certificate-manual-requests/' + this.certificateRequestId;
          }

        this.manualRequestsService.getRules(url).subscribe(res => {
            this.allRulesData(res.body);
            this.getCertificateData();
            
        });
        this.isLoader = false;
    }
    

    previousState() {
        window.history.back();
    }

    verifyRules() {
        let url = 'api/bulk-certificate-request-validate-rule/' + this.certificateRequestId;
        this.manualRequestsService.getRules(url).subscribe(res => {
            this.isRulesVerifiedClicked = true;
            if(res.body.status=="ERROR") {
                console.log(res.body.message);
                this.jhiAlertService.error(res.body.message);
            } else {
                this.rulesData=res.body.payload;
            
                if(this.rulesData) {
                    this.certificateRules=res.body.payload.certificateRules;
                    this.failedRules=res.body.payload.failedRules;
                    this.successRules=res.body.payload.successRules;
                    this.totalRules=res.body.payload.totalRules;
                    this.isVesselScreeningEnabled=res.body.payload.isVesselScreeningEnabled||false;
                    this.isLoader=false;
                    if(res.body.payload.totalRules>=6) {
                        this.showPushNotification=true;
                    }
                } else {
                    this.onError("Some thing went wrong!.");
                    this.rulesData=[];
                    this.getAllRules();
                }
            }
           

            this.rulesData = res.body.payload;
                if (this.rulesData) {
                    this.certificateRules = res.body.payload.certificateRules;
                    this.failedRules = res.body.payload.failedRules;
                    this.successRules = res.body.payload.successRules;
                    this.totalRules = res.body.payload.totalRules;
                    this.isLoader = false;
                    if (res.body.payload.totalRules >=6) {
                        // this.showPushNotification = true;
                        if(res.body.status == "ERROR" && res.body.message==='No active policy found'){
                            this.showPushNotification=false;
                        }else{
                            this.showPushNotification = true;
                        }
                    }
                } else {
                    this.onError("Some thing went wrong!.");
                    this.rulesData = [];
                    this.getAllRules();
                }

        }, (res: any) => this.onError(res.error.message));
        this.isLoader = false;

    }

    pushNotification() {
        let url = 'api/bulk-certificate-request-validate-rule-push-notification/' + this.certificateRequestId;
        this.manualRequestsService.getRules(url).subscribe(res => {
            console.log(res);
            this.jhiAlertService.success(res.body.message, null, null);
        });
    }

    

    viewCertificateRequest() {
        this.bulkDeclarationService.getById('api/bulk-certificate-request/revision-init/'+ + this.certificateRequestId).subscribe(res=>{


        let url = "api/declaration/" + this.certificateRequestId;
        this.bulkDeclarationService.getById(url).subscribe(res => {
            if (CommonUtils.isSame(res.status, MessageConst.SUCCESS)) {
                console.log(res.payload);
                let request=res.payload;
                // if(request.previousDeclarationRequestId==null) {
                    request.id = null;
                    request.certificateRequestNumber = null;
                // }
                this.stateStorageService.storeBulkCertificateDTO(request);
                this.router.navigateByUrl('/my-declaration/declare-shipment');
            } else {
                this.jhiAlertService.error("Sorry,  you don't have any active Policy!", null, null);
            }
        });
        },err=>{
            this.onError(err.message);
        });


    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    calculateAdditionPremium(rule, index) {

        // if(CommonUtils.isNotNil(rule.additionalPremiumRateNumber) && rule.additionalPremiumRateNumber >= 0) {
        //     let additionalPremiumRate = rule.additionalPremiumRateNumber.toString().replace(/[,.]/g, function (
        //         m
        //       ) {
        //         // m is the match found in the string
        //         // If `,` is matched return `.`, if `.` matched return `,`
        //         return m === "." ? "" : ",";
        //       });
        //       //ES6
        //       additionalPremiumRate = additionalPremiumRate.replace(/[,.]/g, m =>
        //         m === "," ? "." : ","
        //       );
          
        //       rule.additionalPremium = this.sumInsuredInPolicyCurrency * (additionalPremiumRate / 100);
          
        //     //   this.additionalPremiumArr[index] = rule.additionalPremiumRate + this.netPremium;
        //       this.additionalPremiumArr[index] = rule.additionalPremium; 
        //       // console.warn(this.additionalPremiumArr[index]);
        // }

        if (CommonUtils.isNotNil(rule.additionalPremiumRateNumber) && rule.additionalPremiumRateNumber >= 0) {

          if(rule.additionalPremiumRateNumber > 100) return;

          // Convert additionalPremiumRateNumber to a string and replace dot with comma
          let additionalPremiumRateString = rule.additionalPremiumRateNumber.toString().replace('.', ',');
  
          // Convert comma-separated string to a number
          let additionalPremiumRate = parseFloat(additionalPremiumRateString.toString().replace(/[,.]/g,function(m) {
            return m==="."?",":"."
          }));
  
          // Calculate the additional premium
          rule.additionalPremium = this.sumInsuredInPolicyCurrency * (additionalPremiumRate / 100);
  
          // Format the additional premium with European number formatting
          let additionalPremiumFormatted = rule.additionalPremium;
  
          // Store the formatted additional premium in the array
          this.additionalPremiumArr[index] = additionalPremiumFormatted;
  
          // Log the formatted additional premium and the actual value
          // console.warn(this.additionalPremiumArr[index], rule.additionalPremium);
      }
        
    }

    onSubmit(rule,index) {
      
      let sum: number = 0;

      sum = this.certificateRules.filter(item => CommonUtils.isNotNil(item.additionalPremiumRateNumber)).reduce((acc, item) => acc + item.additionalPremiumRateNumber, 0);

      if(this.isAutoQuotationDisabled && !this.isAnyRuleApprovedManually && CommonUtils.isNotNil(this.rulesData.additionalPremiumRateAll)) {
        sum += this.rulesData.additionalPremiumRateAll;
      }

      if(sum > 100) {
        this.onError('Sum of additional premium rate must not exceed 100');
        return;
      }


        this.selectedRule=rule;
        this.selectedRuleIndex=index;

        if(this.additionalPremiumRatePostData && this.additionalPremiumRatePostData.vesselName) {
          this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName = this.additionalPremiumRatePostData.vesselName;
        }

        
        if(CommonUtils.isSame(rule.name,'Vessel Screening')&&this.additionalPremiumRatePostData.vesselName==null) {
            if(this.rulesData.isVesselRuleFailed) {
                this.additionalPremiumRatePostData.vesselName=this.summaryDetails.certificateRequestDTO.shipmentDetailsDTO.vesselName;
                this.vesselNameModal.show();
                return;
            } else {
                // for free text popup
                this.hideVesselModel();
            }
        }

        rule.remarks=this.remarks[ index ];
        // console.warn(rule);
        this.remarks=[];
        this.additionalPremiumArr=[];
      if(rule.additionalPremiumRateNumber>=0||this.isPremiumCalculationDisable) {
        this.additionalPremiumRatePostData.certificateRequestId=this.certificateRequestId;
        this.additionalPremiumRatePostData.certificateRuleId=rule.id;
        this.additionalPremiumRatePostData.additionalPremiumRate=this.isPremiumCalculationDisable? 0:rule.additionalPremiumRateNumber;
        this.additionalPremiumRatePostData.remarks=rule.remarks;
        this.additionalPremiumRatePostData.requestRuleTableId=rule.requestRuleTableId;
          
        let url=this.bulkDeclarationService.postAdditionalPremiumRate(this.additionalPremiumRatePostData,this.certificateRequestId);
          
        if(CommonUtils.isTrue(rule.isEditClicked)) {
          url=this.bulkDeclarationService.putAdditionalPremiumRate(this.additionalPremiumRatePostData,this.certificateRequestId);
        }

        url.subscribe((res) => {
          if(res&&res.body&&res.body.payload) {
            this.allRulesData(res.body.payload);
            this.hideVesselModel();
          }
          rule.isEditClicked=false;
        });
        this.isLoader=false;
      }
    }

  allRulesData(res: any) {
    this.rulesData=res;
    this.rulesData.isEditClicked=false;

    this.sumInsuredInPolicyCurrency=this.rulesData.sumInsuredInPolicyCurrency;
    this.certificateRules=res.certificateRules;
    if(this.certificateRules&&this.certificateRules.length>0) {
      //     for (let _rules of this.certificateRules) {
      //         this.isCollapsedArr.push(true);
      //     }

      this.certificateRules.forEach((rule) => {
        this.isCollapsedArr.push(true);
        if(rule.additionalPremiumRateNumber===0) {
          rule.additionalPremiumRateNumber=null;
        }
        
        rule.isEditClicked=false;
        
        if(CommonUtils.isTrue(rule.isApproved)) {
          this.isAnyRuleApprovedManually=true;
        }
      });
    }

    this.failedRules=res.failedRules;
    this.successRules=res.successRules;
    this.totalRules=res.totalRules;
    this.isVesselScreeningEnabled=res.isVesselScreeningEnabled||false;
    this.isLoader=false;

    this.isAutoQuotationDisabled=!res.isAutoQuotation;
  }

    checkPremiumCalculationPermission() {
        this.principal.checkPremiumCalculationAccessForUser().then(res => {
          if(res) {
            console.log("checkPremiumCalculationPermission if",res);
            this.isPremiumCalculationDisable=false;
          } else {
            console.log("checkPremiumCalculationPermission else",res);
            this.isPremiumCalculationDisable=true;
          }
        });
    }


    calculateAdditionPremiumForAutoQuotation() {
      if(CommonUtils.isNotNil(this.additionalPremiumRateAll) && this.additionalPremiumRateAll >= 0) {
          // Convert additionalPremiumRateNumber to a string and replace dot with comma
        let additionalPremiumRateString=this.additionalPremiumRateAll.toString().replace('.',',');
  
          // Convert comma-separated string to a number
        let additionalPremiumRate= parseFloat(additionalPremiumRateString.toString().replace(/[,.]/g,function(m) {
          return m==="."?",":"."
        }));
    
        if(additionalPremiumRate<0||this.additionalPremiumRateAll<0) {
          additionalPremiumRate=0;
          this.additionalPremiumAll=0;
          this.additionalPremiumRateAll=0;
        }
          
        this.additionalPremiumAll=this.sumInsuredInPolicyCurrency*(additionalPremiumRate/100);

        this.additionalPremiumAll = this.additionalPremiumAll.toFixed(4);

        // console.warn(this.additionalPremiumArr[index]);
      }
          
    }
    
    submitAdditionalPremiumForAutoQuotation() {
      // console.warn(rule);
      this.remarks=[];
      this.additionalPremiumArr=[];
          
      if( this.isPremiumCalculationDisable || this.additionalPremiumRateAll>=0) {
        this.additionalPremiumRatePostData.certificateRequestId=this.certificateRequestId;
        this.additionalPremiumRatePostData.certificateRuleId=null;
        this.additionalPremiumRatePostData.additionalPremiumRate= this.isPremiumCalculationDisable?0: this.additionalPremiumRateAll;
        this.additionalPremiumRatePostData.remarks=this.remarksForAll
        this.additionalPremiumRatePostData.requestRuleTableId=null;
        
        let url=this.bulkDeclarationService.postAdditionalPremiumRateForBulk(this.additionalPremiumRatePostData,this.certificateRequestId);
        
        if(this.rulesData.isEditClicked) {
          url=this.bulkDeclarationService.putAdditionalPremiumRateForBulk(this.additionalPremiumRatePostData,this.certificateRequestId);
        }

        url.subscribe((res) => {
          if(res&&res.body&&res.body.payload) {
            this.allRulesData(res.body.payload);
          }
        });

        this.isLoader=false;
      }
    }

 
    getCertificateData() {
        let url ="api/bulk-certificate-requests/" +this.certificateRequestId +"/scopes/" +this.rulesData.scopeId;
          
        this.bulkDeclarationService.getById(url).subscribe(res => {
          this.summaryDetails = res.payload;
        });
      }
 
      spaceNotAllowedAtFirst(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode == 32 && event.target.value.length == 0) {
          return false;
        }
      }
 
  hideVesselModel(): void {
    // this.isVesselName = true;
    this.additionalPremiumRatePostData.vesselName=null
    this.vesselNameModal.hide();
    this.getCertificateData();
    $(document.body).removeClass("modal-open");
  }
 
  editRule(rules,i) {
    rules.isEditClicked=true;
    this.additionalPremiumArr[ i ]=rules.additionalPremiumNumber;
    this.remarks[i]=rules.remarks
  }

  editRuleForAll(rulesData) {
    rulesData.isEditClicked=true;
    this.additionalPremiumRateAll=rulesData.additionalPremiumRateAll;
    this.additionalPremiumAll=rulesData.additionalPremiumAllNumber;
    this.remarksForAll=rulesData.remarksForAllRules
  }
    
}